import React, { useState, useEffect} from "react";
import Joyride, { CallBackProps, STATUS, Step } from "react-joyride";
import IntroOverlay from "./IntroOverlay";
import { useTranslation } from "react-i18next";
import CustomTooltip from "./shared/CustomTooltip";



const Tour = ({ onFinish }: {onFinish: () => void }) => {

  const [showIntro, setShowIntro] = useState(false);
  const [showJoyride, setShowJoyride] = useState(false);
  const { t } = useTranslation();
 
  const [stepIndex, setStepIndex] = useState(0);



const steps: Step[] = [
  {
    target: '[data-tour="sidebar-skillary"]',
    content: t("tour.sidebar.skillary"),
  },
  {
    target: '[data-tour="sidebar-myskills"]',
    content: t("tour.sidebar.myskills"),
  },
  {
    target: '[data-tour="sidebar-skillboard"]',
    content: t("tour.sidebar.skillboard"),
  },
  {
    target: '[data-tour="sidebar-skillbox"]',
    content: t("tour.sidebar.skillbox"),
  },
  {
    target: '[data-tour="sidebar-skillcards"]',
    content: t("tour.sidebar.skillcards"),
  },
];

    useEffect(() => {
      setShowIntro(true);
    }, []);




const handleJoyrideCallback = (data: CallBackProps) => {
  if (["finished", "skipped"].includes(data.status)) {
    onFinish();
  }
};
  

   return (
    <>

      {showIntro &&(
        <IntroOverlay onComplete={() => 
          [setShowIntro(false), setShowJoyride(true)]} />
      )}
      {showJoyride &&(
        <Joyride
          run
          steps={steps}
          stepIndex={stepIndex}
          callback={handleJoyrideCallback}
          continuous
          showSkipButton
          scrollToFirstStep
          disableScrolling
          disableOverlayClose
          spotlightClicks
          showProgress
          tooltipComponent={(props) => (
          <CustomTooltip {...props} stepIndex={stepIndex} setStepIndex={setStepIndex} onManualFinish={() => {
            onFinish();
          }} />
          )}
          locale={{
            back: t("Zurück"),
            close: t("Schließen"),
            last: t("Fertig"),
            next: t("Weiter"),
            skip: t("Überspringen")
          }}
          styles={{
            options: {
              zIndex: 9999,
              primaryColor: "#a1b7a5",
              backgroundColor: "#fff",
              textColor: "#333",
              arrowColor: "#fff",
              overlayColor: "rgba(0, 0, 0, 0.5)",
            },
            tooltipContainer: {
              textAlign: "center",
              borderRadius: "10px",
            },
            spotlight: {
              borderRadius: "10px",
              boxShadow: "0 0 0 4px rgba(255, 255, 255, 0.5)",
            },
          }}
        />
        
        )}
    
    </>
    
  );
};

export default Tour;
